
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import NeighbourhoodGuides from "../pages/neighbourhood-guides/page";
import RefinanceOptions from "../pages/refinance/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/neighbourhood-guides",
    element: <NeighbourhoodGuides />,
  },
  {
    path: "/refinance-options",
    element: <RefinanceOptions />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
